// Maps an avocado.data_program row onto the program entity shape callers of
// `program.list()`/`program.get()` already expect.
//
// The exact inverse of what the sync writes: it stores
// `{ fsid: id, name, options }`, where `options` is the legacy couch entity
// minus `id`/`name` (see
// backend/stacks/program_service_sync/avocado_from_couch_program_service).
// So flattening `options` back out and restoring the fsid-based `id` rebuilds
// the legacy entity exactly.
//
// Deliberately a whitelist rather than a `...rest` spread: the row also carries
// the PG primary key `id` (which must not win over the fsid) and
// `created_at`/`updated_at`, which the sync rewrites to roughly "now" on every
// run. Program couch docs carry no per-program timestamps, so passing those
// through would add fields that are neither the legacy shape nor truthful.
const pgRowToProgram = row => {
  if (!row) return row
  const { fsid, name, options } = row
  return { ...(options || {}), id: fsid, name }
}

module.exports = { pgRowToProgram }
